import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		dropdown: {
			maxHeight: 280,
			overflowY: "auto",
			marginTop: 4,
		},
		selectAllRow: {
			borderBottom: `1px solid ${theme.palette.divider}`,
		},
		chipContainer: {
			display: "flex",
			flexWrap: "wrap",
			gap: 8,
			marginTop: 16,
		},
		emptyText: {
			fontStyle: "italic",
			color: theme.palette.text.secondary,
			marginTop: 16,
		},
	} satisfies Record<string, CSSObject>);
};
